import { jsx } from 'react/jsx-runtime';
import { styled } from '@mui/material/styles';
import Checkbox from '../../Checkbox/Checkbox.js';
import '../../Checkbox/CheckboxList.js';
import { useGroup } from '../context/GroupProvider.js';

const BaseOptionItem = styled(Checkbox, { shouldForwardProp: prop => !['isInGroup'].includes(prop) }) `
  width: 100%;
  padding: ${({ theme, isInGroup = false }) => theme.spacing(1.25, 1.5, 1.25, isInGroup ? 5.5 : 2.5)};
  p:first-of-type {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    margin: ${({ theme }) => theme.spacing(0, 0, 0, 2)};
  }
  ${({ theme, disabled }) => !disabled &&
    `
    :hover, :focus {
      p:first-of-type {
        color: ${theme.palette.N05.main};
      }
      color: ${theme.palette.N05.main};
      background-color: ${theme.palette.N30.main};
    }
  `};
`;
const OptionItem = ({ innerProps, isSelected, data }) => {
    const { label, hint, hintDuration, disabled, component: LabelComponent } = data;
    const { isInGroup } = useGroup();
    return (jsx(BaseOptionItem, Object.assign({ hint: hint, hintDuration: hintDuration, disabled: disabled, checked: isSelected, onChange: () => {
            // @ts-ignore
            innerProps.onClick();
        }, isInGroup: isInGroup, "data-testid": `option-${label}` }, { children: LabelComponent ? jsx(LabelComponent, { label: label }) : label })));
};

export { BaseOptionItem, OptionItem as default };
//# sourceMappingURL=OptionItem.js.map
